export const commonCardWidth = '420px';
export const commonCardHeight = '560px';
export const signUpCardWidth = '520px';
